function spanWrap(classname) {
    const targets = document.querySelectorAll(classname)
    targets.forEach(function (target) {
        let nodes = [...target.childNodes];
        let textBox = '';
        nodes.forEach(function (node) {
            if (node.nodeType == 3) { //テキストの場合
                let text = node.textContent.replace(/\r?\n/g, ''); //テキストから改行コード削除
                text.split('').forEach(function (t, i) {
                    if (t !== " ") {
                        let n = i / 40;
                        textBox += '<span class="char c-0' + (i + 1) + '" ' + 'style="animation-delay:' + n + 's;">' + t + '</span>';
                    } else {
                        textBox += t;
                    }
                });
            } else if (node.contains(node) == true) { // テキストではなく、子ノード(=span要素)を持つ
                // そのまま連結
                textBox = textBox + node.outerHTML;
            } else { // テキストではなく、br要素などspan要素以外の要素を持つ
                // そのまま連結　※br要素などをspan要素とは別に処理する場合はここに書く
                textBox = textBox + node.outerHTML;
            }
        })
        target.innerHTML = textBox
    })
}

export function spanwrapinit() {
    if (location.pathname == "/") {
        spanWrap(".oneby1")
    }
}